<p-dialog header="Resumen de datos de lotes"
          [modal]="true" 
          [closable]="true"
          [draggable]="false" 
          [resizable]="false"
          styleClass="p-dialog-resumen-custom" 
          [(visible)]="isOpen"  
          (onHide)="closeModal()"
          [style]="{ width: '1000px' }">
    <div class="modal-content">
      <p-table [value]="lotes" [paginator]="true" [rows]="5" [responsive]="true" [style]="{ width: '100%' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Nro Lote</th>
            <th>Trabajadores</th>
            <th>Exámenes Asignados</th>
            <th>Exámenes Cargados</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-lote>
          <tr>
            <td>{{ lote.nroLote !== null ? lote.nroLote : 0 }}</td>
            <td>{{ lote.cantTrabajadoresLote !== null ? lote.cantTrabajadoresLote : 0 }}</td>
            <td>{{ lote.cantExaAsignados !== null ? lote.cantExaAsignados : 0 }}</td>
            <td>{{ lote.cantExaCargados !== null ? lote.cantExaCargados : 0 }}</td>
          </tr>
        </ng-template>
      </p-table>
      <!-- Botón de ACTUALIZAR -->
      <div style="margin-top: 1em;">
        <button pButton type="button" label="ACTUALIZAR" icon="pi pi-refresh" 
                (click)="updateData()" style="width: 9em; height: 3em; margin-left: 25em;"></button>
      </div>
    </div>
</p-dialog>